// extracted by mini-css-extract-plugin
export default {"container":"ver_2YVQd","inner":"ver_inn_3Wm4U","thumbnail":"ver_thu_Nu6Ru","label":"ver_lab_1pBYX"};